{
  "help": "Βοήθεια",
  "info": "Πληροφορίες"
}
